import { UserMenu as UserMenuV1 } from 'app/menu/components/TopBarV1/User'

export const UserMenu = UserMenuV1
export default UserMenu
